module.exports = __webpack_public_path__ + "static/media/varal-sanfonado.fa9438f9.png";